import { global } from ":shared/app";
import type { UserRequests } from "../../SHARED/_model";

export interface Put {
  props: {
    item: UserRequests["received_requests"][number];
    status: string;
  };
  returns: UserRequests;
}

const endpoint = "/teaming/accept-request/";
export default {
  async put(props: Put["props"]): Promise<Put["returns"]> {
    const jwt = global.api.auth.token.decoded();
    const receiver_email = jwt?.email_address;
    const data = {
      id: props.item.id,
      receiver_email,
      requester_email: props.item.email,
      status: props.status,
      type: props.item.type,
    };
    return global.api.putAuth(endpoint, data).then((res) => {
      return res.data;
    });
  },
};
